import React,{useState, useRef, useEffect, useLayoutEffect, useContext} from 'react'
import { NavLink, useLoaderData, useParams,useLocation, useNavigate } from "react-router-dom"
import { ThemeContext } from '../context/ThemeContext';
import { useDarkMode } from '../customhooks/ThemeHook';
import {SplitText} from "@cyriacbr/react-split-text"
import TitleAnimated from './TitleAnimated'
import { BeakerIcon } from '@heroicons/react/24/solid'
import { Helmet } from 'react-helmet';
import YouTube from "react-youtube";
import gsap from 'gsap'
//import { SplitText } from "gsap/SplitText"


var opts = {}

function WorkView(props) {

  function projectDataAfp(slug,data){
    // the code you're looking for
    var slug = slug;
    var obj = data;
    // iterate over each element in the array
    for (var i = 0; i < obj.length; i++){
      // look for the entry with a matching `code` value
      if (obj[i].slug == slug){
         // we found it
         //console.log(obj[i]);
         return (obj[i]);
      }
    }
  }
const location = useLocation();
const navigate = useNavigate();
const theme = useContext(ThemeContext);
const { id } = useParams();


  let projects = (useLoaderData());
  //console.log(projects);
const urlChunk = location.pathname.split('/');





  //const featuredImgRef = useRef();

  const [projDataAfp, setProjDataAfp] = useState();
  const [scrollValue, setScrollValue] = useState(0);
  const [featuredImage, setFeaturedImage] = useState();
  const [posterImage, setPosterImage] = useState();
  const [featuredImageOne, setFeaturedImageOne] = useState();
  const [videoId, setVideoId] = useState(null);
  const [isPlayer,setIsPlayer] = useState(null);






useEffect((props)=> {
document.body.classList.add('path-0','path-1');
},[]);



useEffect((props)=> {
  if(projDataAfp){
    //console.log(projDataAfp.yt);
    if(projDataAfp.yt.length !== 0){
    setVideoId(projDataAfp.yt.resourceId.videoId);


    opts = {
      width: theme.state.width,
      height: theme.state.height,
      playerVars: {
        autoplay: 1,
        muted: 1,
        controls: 0,
        enablejsapi: 1,
        fs: 0,
        loop: 1,
        rel: 0,
        modestbranding: 1,
        showinfo: 0,
        playlist: projDataAfp.yt.resourceId.videoId ? projDataAfp.yt.resourceId.videoId : 'PLHeUFog1D_MuNeT_OZ0fVtsChMIW0KL-p',
        hd:1,
        //origin: 'frankariza.com'
      },
    };
  }
  }
},[projDataAfp,theme.state.width]);


useLayoutEffect(()=>{

  var _projDataAfp = projectDataAfp(id,projects.items);
  setProjDataAfp(_projDataAfp);
  setFeaturedImage(_projDataAfp.image_thumb_bg.url);
  setPosterImage(_projDataAfp.image_thumb.url);
  setFeaturedImageOne(_projDataAfp.image_thumb_1.url);


  //console.log('yt',_projDataAfp.yt != null ? 'YT ' + _projDataAfp.yt.resourceId.videoId : 'no YT');




  },[location,projDataAfp]);







  return (


  <div className="relative center items-center">



  <div id="-project-page" className={"-parallax bg-dark " + props.transition}>


  <div style={{backgroundColor: '#000', backgroundImage: 'url(' + featuredImage + ')',backgroundPosition:'center', backgroundSize:'cover'}} className="relative background-cover h-[70vh] md:h-[100vh]">


    <div style={{display:'flex', height:'100vh'}} className="">

      { projDataAfp &&  projDataAfp.image_logo != null ?
      <div className="absolute bottom-12 md:bottom-18 left-6 md:left-24 text-white"><img className="w-[200px] md:w-[480px]" src={projDataAfp.image_logo} alt="item.logo"/></div>
      :
      <div style={{alignSelf:'center',margin:'0 auto'}} className="sm:overflow-hidden w-[98%] md:w-[80%] p-0 mt-1 pb-4">
      <TitleAnimated
      level={1}
      id_t={'project_title'}
      classes={'notranslate proj-title text-left  roboto-bold pt-6  lg:pt-31 xl:pt-80 pb-4 pl-8 text-6xl leading-6*2'}
      letterSpeed={0.02}
      scale={1.0}
      color="white"
      title={projDataAfp ? projDataAfp.name :'...'}
      afterTitle={true}
      />

    </div>
   }


  </div>

</div>


<section className="px-8 md:px-24">
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-12">
  <div className="order-2 sm:order-1 text-gray-900 text-left">
    <div className="pt-6  text-left" dangerouslySetInnerHTML={{__html: projDataAfp ? projDataAfp.description :'...' }}/>
  </div>
  <div className="order-1 sm:order-2 text-center">
    { projDataAfp && projDataAfp.slug === 'fragmentos' ?
      <p className="text-gray-900 font-semibold pt-6" dangerouslySetInnerHTML={{__html: projDataAfp ? projDataAfp.note :'' }}/>

  : '' }
    <img style={{maxWidth:'360px',margin:'0 auto'}} className="p-0  md:p-6 w-full" src={posterImage} alt=""/>
  </div>
</div>
</section>

<section id="videoSection" className={"w-full bg-dark px-0 relative " + props.transition}>
{ videoId ? <YouTube
          videoId={videoId}
          onReady={(e)=>{
            const player = e.target;
            player.seekTo(0);
            setIsPlayer(player);
          }}
          opts={opts}
          className={'ytPlayer'}
          style={{maxWidth: 1380+'px', height: 'auto',}}
        />
        :
        ''
      }
</section>
  { projDataAfp && projDataAfp.slug === 'fragmentos' ?
<section className="mt-4">
<div style={{ padding:'54.05% 0 0 0', position:'relative'}}>
  <iframe src="https://player.vimeo.com/video/1118667589?h=6ea082d670&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{position:'absolute',top:0,left:0,width:'100%',height:'100%'}} title="FRAGMENTOS_TRAILER_QT_H264"></iframe>
</div>

</section>
: '' }

<section className={ "px-8 md:px-24 pt-12 " + props.transition}>


    <div className="grid grid-cols-1 sm:grid-cols-2 gap-12">
        <div  className="text-left text-gray-900">

        {projDataAfp && projDataAfp.desc_art ?   <h3 className="text-6xl capitalize pb-6"> Ficha art&iacute;stica </h3> : ''}
      { projDataAfp ?  <div className="text-gray-900" dangerouslySetInnerHTML={{__html: projDataAfp ? projDataAfp.desc_art :'' }}/> : ''}

        </div>

        <div  className="text-left text-gray-900">
          {projDataAfp && projDataAfp.desc_tec ?  <h3 className="text-6xl capitalize pb-6">Ficha t&eacute;cnica</h3> : ''}
            <div className="text-gray-900" dangerouslySetInnerHTML={{__html: projDataAfp ? projDataAfp.desc_tec :'' }}/>
        </div>


    </div>
    <div style={{borderTop:'0.5px solid #000'}} className="text-center font-medium text-gray-900 mt-12 pt-12 ">
      {projDataAfp  ?
      projDataAfp.tax[0].id != 4 ?
      <NavLink to={"/"+ projDataAfp.tax[0].slug} onClick={() => { setTimeout(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, 800); }}>{'+ ' + projDataAfp.tax[0].name}
      </NavLink> :
      <NavLink to="/#in-produccion">Volver</NavLink>
      : ''}
  </div>


</section>


</div>
</div>
  )
}

export default WorkView
